import { Button, Checkbox, Col, Input, Modal, Row, Select } from "antd";
import { otherAuxilaryMachineData } from "../../../../Data/data";
import { useEffect, useState } from "react";
import { Option } from "antd/es/mentions";

const AddOtherMachinaryModel = ({ responeData, visible, onOk, onCancel }) => {
  const [machinary_name, set_machinary_name] = useState("");
  const [machinary_make, set_machinary_make] = useState("");
  const [machinary_model, set_machinary_model] = useState("");
  const [description, set_description] = useState("");
  const [specification, set_specification] = useState("");
  const [machinary_dropdown, set_machinary_dropdown] = useState("-- Select Machinery --");
  const [errors, set_errors] = useState({});
  const [fields_name, set_fields_name] = useState("");
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  useEffect(() => {
    if (responeData) {
      set_machinary_make(responeData?.machinary_make);
      set_machinary_model(responeData?.machinary_model);
      set_machinary_name(responeData?.machinary_name);
      set_specification(responeData?.specification);
      set_description(responeData?.description);
      setSelectedParams(responeData?.selected_parameters);
      set_machinary_dropdown(responeData?.machinary_selected_dropdown);
      // setCustomParams(responeData?.other_parameters  ||[])}
      setCustomParams(
        Array.isArray(responeData?.other_parameters) ? responeData?.other_parameters : []
      );
    }
  }, [responeData]);

  useEffect(() => {
    const selectedData = otherAuxilaryMachineData?.find(
      (item) => item?.label?.toUpperCase() == machinary_dropdown
    );

    if (selectedData) {
      setSelectedParams(selectedData.parameters); // ✅ set only relevant params
    } else {
      setSelectedParams([]); // In case no match (like "OTHER")
    }
  }, [machinary_dropdown]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    const updated = [...customParams];
    updated.splice(index, 1);
    setCustomParams(updated);
  };

  const handleSubmit = () => {
    const data = {
      machinary_name,
      machinary_make,
      machinary_model,
      machinary_dropdown,
      description,
      specification,
      selectedParams,
      customParams,
    };
    onOk(data);
  };

  const handleCheckbox = (item) => {
    setSelectedParams((prev) => {
      if (prev.includes(item)) {
        // If item already exists in selectedParams, remove it
        return prev.filter((param) => param !== item);
      } else {
        // If item does not exist, add it
        return [...prev, item];
      }
    });
  };

  return (
    <>
      <Modal title="Add Machinary" visible={visible} onOk={handleSubmit} onCancel={onCancel}>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Select Machinery</label>
            <br />
            <Select
              style={{ width: "100%" }}
              className="form-control"
              value={machinary_dropdown}
              onChange={(value) => set_machinary_dropdown(value)}
            >
              <Option value="">-- Select Machinery --</Option>
              <Option value="FRESH WATER GENERATOR">FRESH WATER GENERATOR</Option>
              <Option value="AIR CONDITIONING PLANT">AIR CONDITIONING PLANT</Option>
              <Option value="REFRIGERATION PLANT">REFRIGERATION PLANT</Option>
              <Option value="OTHER">OTHER</Option>
            </Select>

            {errors?.machinary_name && (
              <span style={{ color: "red" }}>{errors?.machinary_name}</span>
            )}
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Machinary Name</label>
            <Input
              type="text"
              placeholder="Machinary Name"
              value={machinary_name}
              onChange={(e) => set_machinary_name(e.target.value)}
            />
            {errors?.machinary_name && (
              <>
                <span style={{ color: "red" }}>{errors?.machinary_name}</span>
              </>
            )}
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Machinary Make</label>
            <Input
              type="text"
              placeholder="Machinary Make"
              value={machinary_make}
              onChange={(e) => set_machinary_make(e.target.value)}
            />
            {errors?.machinary_make && (
              <>
                <span style={{ color: "red" }}>{errors?.machinary_make}</span>
              </>
            )}
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Machinary Model</label>
            <Input
              type="text"
              placeholder="Machinary Model"
              value={machinary_model}
              onChange={(e) => set_machinary_model(e.target.value)}
            />
            {errors?.machinary_model && (
              <>
                <span style={{ color: "red" }}>{errors?.machinary_model}</span>
              </>
            )}
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Description</label>
            <Input
              type="text"
              placeholder="Description"
              value={description}
              onChange={(e) => set_description(e.target.value)}
            />
            {errors?.description && (
              <>
                <span style={{ color: "red" }}>{errors?.description}</span>
              </>
            )}
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Specification</label>
            <Input
              type="text"
              placeholder="Specification"
              value={specification}
              onChange={(e) => set_specification(e.target.value)}
            />
            {errors?.specification && (
              <>
                <span style={{ color: "red" }}>{errors?.specification}</span>
              </>
            )}
          </div>
        </div>

        <div>
          {machinary_dropdown === "FRESH WATER GENERATOR" && (
            <>
              <div style={{ display: "flex" }}>
                <div className="col-12">
                  {otherAuxilaryMachineData[0]?.parameters
                    ?.slice(0, Math.ceil(otherAuxilaryMachineData[0].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)} // Check if the item is in selectedParams
                          onChange={() => handleCheckbox(item)} // Pass item to handleCheckbox
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>

                <div className="col-12">
                  {otherAuxilaryMachineData[0]?.parameters
                    ?.slice(Math.ceil(otherAuxilaryMachineData[0].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)} // Check if the item is in selectedParams
                          onChange={() => handleCheckbox(item)} // Pass item to handleCheckbox
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <b>Add Other Parameters</b>
                {customParams?.map((param, index) => (
                  <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                    <Col span={10}>
                      <Input
                        placeholder="Parameter"
                        value={param.name}
                        maxLength={50}
                        onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                      />
                    </Col>
                    <Col span={10}>
                      <Input
                        placeholder="Unit"
                        value={param.unit}
                        maxLength={10}
                        onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                      />
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => handleDeleteParam(index)} block>
                        ×
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Button
                  type="dashed"
                  onClick={handleAddParam}
                  style={{ marginTop: 12, marginLeft: 5 }}
                >
                  + Add Parameter
                </Button>
              </div>
            </>
          )}
        </div>

        <div>
          {machinary_dropdown === "AIR CONDITIONING PLANT" && (
            <>
              <div style={{ display: "flex" }}>
                <div className="col-12">
                  {otherAuxilaryMachineData[1]?.parameters
                    ?.slice(0, Math.ceil(otherAuxilaryMachineData[1].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)}
                          onChange={() => handleCheckbox(item)}
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>

                <div className="col-12">
                  {otherAuxilaryMachineData[1]?.parameters
                    ?.slice(Math.ceil(otherAuxilaryMachineData[1].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)}
                          onChange={() => handleCheckbox(item)}
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <b>Add Other Parameters</b>
                {customParams?.map((param, index) => (
                  <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                    <Col span={10}>
                      <Input
                        placeholder="Parameter"
                        value={param.name}
                        maxLength={50}
                        onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                      />
                    </Col>
                    <Col span={10}>
                      <Input
                        placeholder="Unit"
                        value={param.unit}
                        maxLength={10}
                        onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                      />
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => handleDeleteParam(index)} block>
                        ×
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Button
                  type="dashed"
                  onClick={handleAddParam}
                  style={{ marginTop: 12, marginLeft: 5 }}
                >
                  + Add Parameter
                </Button>
              </div>
            </>
          )}
        </div>

        <div>
          {machinary_dropdown === "REFRIGERATION PLANT" && (
            <>
              <div style={{ display: "flex" }}>
                <div className="col-12">
                  {otherAuxilaryMachineData[2]?.parameters
                    ?.slice(0, Math.ceil(otherAuxilaryMachineData[2].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)}
                          onChange={() => handleCheckbox(item)}
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>

                <div className="col-12">
                  {otherAuxilaryMachineData[2]?.parameters
                    ?.slice(Math.ceil(otherAuxilaryMachineData[2].parameters.length / 2))
                    ?.map((item, index) => (
                      <div key={index} className="col-12">
                        <Checkbox
                          checked={selectedParams.includes(item)}
                          onChange={() => handleCheckbox(item)}
                        >
                          {item}
                        </Checkbox>
                      </div>
                    ))}
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <b>Add Other Parameters</b>
                {customParams?.map((param, index) => (
                  <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                    <Col span={10}>
                      <Input
                        placeholder="Parameter"
                        value={param.name}
                        maxLength={50}
                        onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                      />
                    </Col>
                    <Col span={10}>
                      <Input
                        placeholder="Unit"
                        value={param.unit}
                        maxLength={10}
                        onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                      />
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => handleDeleteParam(index)} block>
                        ×
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Button
                  type="dashed"
                  onClick={handleAddParam}
                  style={{ marginTop: 12, marginLeft: 5 }}
                >
                  + Add Parameter
                </Button>
              </div>
            </>
          )}
        </div>
        <div>
          {machinary_dropdown === "OTHER" && (
            <div style={{ marginTop: 16 }}>
              <b>Add Other Parameters</b>
              {customParams?.map((param, index) => (
                <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                  <Col span={10}>
                    <Input
                      placeholder="Parameter"
                      value={param?.name}
                      maxLength={50}
                      onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                    />
                  </Col>
                  <Col span={10}>
                    <Input
                      placeholder="Unit"
                      value={param.unit}
                      maxLength={10}
                      onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                    />
                  </Col>
                  <Col span={4}>
                    <Button danger onClick={() => handleDeleteParam(index)} block>
                      ×
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button
                type="dashed"
                onClick={handleAddParam}
                style={{ marginTop: 12, marginLeft: 5 }}
              >
                + Add Parameter
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
export default AddOtherMachinaryModel;
